import { GridRenderCellParams, GridColDef } from '@mui/x-data-grid-premium'
import { TableCell } from '@ketch-com/deck'
import { PurposeDTO } from 'interfaces/purposes/purpose'
import { Typography } from '@mui/material'
import { PolicyScopeDTO } from 'interfaces/policyScopes/policyScope'
import { find } from 'lodash'
import { LegalBaseDTO } from 'interfaces/legalBases/legalBase'

export const legalBasisGridColumns = (
  purpose: PurposeDTO,
  legalBases: LegalBaseDTO[],
): GridColDef<PolicyScopeDTO>[] => [
  {
    align: 'left',
    field: 'name',
    headerAlign: 'left',
    headerName: 'Jurisdiction',
    minWidth: 250,
    flex: 1,
    sortable: false,
    renderCell: ({ row }: GridRenderCellParams<PolicyScopeDTO>) => {
      return <TableCell title={row.name} subTitle={row.code} />
    },
  },
  {
    align: 'left',
    field: 'assignment',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Legal Basis Assignment',
    sortable: false,
    renderCell: ({ row: policyScope }: GridRenderCellParams<PolicyScopeDTO>) => {
      const legalBaseCode = purpose.legalBases?.[policyScope.code]
      const legalBase = find(legalBases, { code: legalBaseCode })

      if (!legalBaseCode) {
        return (
          <TableCell>
            <Typography color="lightGrey.main">None</Typography>
          </TableCell>
        )
      }

      return <TableCell title={legalBase?.name} />
    },
  },
  {
    field: 'requiresDisplay',
    headerName: 'Displayed in Experience',
    sortable: false,
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    renderCell: ({ row: policyScope }: GridRenderCellParams<PolicyScopeDTO>) => {
      const requiresDisplay = purpose.requiresDisplay?.[policyScope.code]

      return <TableCell title={requiresDisplay ? 'Yes' : 'No'} />
    },
  },
]
